<template>
    <footer class="footer">
        <section class="social">
            <span>
                Want to find out more about myself? Check out my
                <a class="twitter" href="https://twitter.com/bartatoni"><strong>Twitter</strong></a> or my
                <a href="https://www.instagram.com/_gottolovelife_/"><strong>Instagram</strong></a> account.
            </span>
        </section>
        <section class="legal">
            <span>Built by Toni Barta. All rights reserved.</span>
        </section>
    </footer>
</template>

<script>
  export default {
    name: 'Footer',
  }
</script>

<style>
.footer {
    padding: 2rem 1.0rem 2rem !important;
    background-color: #d2d2d2 !important;
}
.social {
    padding-bottom: 4px;
}
</style>